document.addEventListener("DOMContentLoaded", function () {
  // Ensure Swym Wishlist is initialized
  if (window._swat) {
    console.log("Swym Wishlist API is loaded.");
    
    // Initialize all wishlist buttons
    window._swat.initializeActionButtons(".swym-add-to-wishlist", {
      onClick: function (product) {
        console.log(`Product ${product.id} added to wishlist.`); // Debug log
      },
    });

    // Handle icon click and toggle state
    const wishlistButtons = document.querySelectorAll(".swym-add-to-wishlist");
    wishlistButtons.forEach((button) => {
      button.addEventListener("click", function () {
        console.log("Wishlist button clicked."); // Debug log

        // Toggle 'active' class to change icon visually
        button.classList.toggle("active");

        // Optionally, toggle the heart icon style
        const heartIcon = button.querySelector(".icon");
        if (heartIcon) {
          heartIcon.classList.toggle("filled");
        }
      });
    });
  } else {
    console.log("Swym Wishlist API not loaded.");
  }
});
